import React from 'react'
import { Button, IconButton, Tooltip, Typography } from '@mui/material'
import { IconDownload } from '@tabler/icons-react'
import { DropzoneRootProps, FileWithPath } from 'react-dropzone'
import { shortenFileName } from '../../../utils/tools'

import './style.scss'
import { FileExtensionImg } from '../FileViewRow/components/FileExtensionImg'

interface Iprops {
  getRootProps: <T extends DropzoneRootProps>(props?: T | undefined) => T
  getInputProps: <T extends DropzoneRootProps>(props?: T | undefined) => T
  acceptedFiles: readonly FileWithPath[]
  isDragActive: boolean
  title: string
  withResults?: boolean
  showButton?: boolean
  supportedFormats?: string[]
}
const FileUploadArea: React.FC<Iprops> = ({
  getRootProps,
  isDragActive,
  getInputProps,
  acceptedFiles,
  withResults,
  showButton = true,
  supportedFormats,
}) => {
  const rootProps = getRootProps({ className: 'dropArea' })
  const inputProps = getInputProps()

  return (
    <div className="FileUploadArea">
      <div className="dropzone">
        <div className="container">
          <div {...rootProps}>
            <input {...inputProps} />
            <div className="rectangel">
              {isDragActive ? (
                <p>Drop the files here</p>
              ) : (
                <div>
                  <Typography variant="h6">Drag & Drop files to upload</Typography>
                  {showButton && (
                    <>
                      <p>or</p>
                      <Button variant="contained" color="secondary" className="button">
                        Select files
                      </Button>
                    </>
                  )}
                  {supportedFormats && (
                    <p className="supportedFormats">
                      Supported formats: {supportedFormats.join(', ')}
                    </p>
                  )}
                </div>
              )}
            </div>
          </div>
          <div className="results">
            {withResults && acceptedFiles.length ? (
              <div className="ResultFileList">
                <Typography variant="h5" sx={{ marginBottom: '8px' }}>
                  Uploaded Files
                </Typography>
                {acceptedFiles.map((i) => (
                  <ResultFile key={`preview-${i.name}`} fileName={i.name} file={i} />
                ))}
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  )
}

export default FileUploadArea

interface IresultFile {
  fileName: string
  file: File
}

const ResultFile = ({ fileName, file }: IresultFile) => {
  return (
    <div className="ResultFile FileViewRow">
      <div>{<FileExtensionImg fileType={file.type} />}</div>
      <div
        className="iconAndName"
        onClick={() => {
          const url = URL.createObjectURL(file)
          const a = document.createElement('a')
          a.style.display = 'none'
          a.href = url
          a.download = fileName
          document.body.appendChild(a)
          a.click()

          setTimeout(() => {
            window.URL.revokeObjectURL(url)
            document.body.removeChild(a)
          }, 100)
        }}
      >
        <Tooltip title={fileName}>
          <Typography className="fileName">{shortenFileName(fileName)}</Typography>
        </Tooltip>
      </div>
      <div className="icons">
        <Tooltip title="Download">
          <IconButton
            onClick={() => {
              const url = URL.createObjectURL(file)
              const a = document.createElement('a')
              a.style.display = 'none'
              a.href = url
              a.download = fileName
              document.body.appendChild(a)
              a.click()

              setTimeout(() => {
                window.URL.revokeObjectURL(url)
                document.body.removeChild(a)
              }, 100)
            }}
            className="iconOpenImage"
          >
            <IconDownload color="blue" />
          </IconButton>
        </Tooltip>
      </div>
    </div>
  )
}
